<button class="btn btn-success d-none" (click)="downloadUnenrolledUsers()">Download Unenrolled Users</button>

<app-multi-select-container [selectedItems]="selectedUsers" [availableItems]="userTableSource.count()"
[shownItems]="shownItems" (selectAll)="onSelectAll()" (deselectAll)="onDeselectAll()" itemName="users">
    <ng2-smart-table class="sticky-multi-select" [settings]="userTableSettings" allowPaging='true' [source]="userTableSource"
    (userRowSelect)="onRowSelect($event)" #tableUsers></ng2-smart-table>
</app-multi-select-container>
